import type { IconPrimitives, IconProps } from './types';

export const buildStatusIcons = ({ Svg, Path, Circle, Rect, Ellipse, defaultColor }: IconPrimitives) => ({
  OnlineIcon: ({ color = defaultColor, size = 24, ...props }: IconProps) => (
    <Svg width={size} height={size} viewBox='0 0 24 24' fill='none' {...props}>
      <Path d='M8.23303 15.5L11.4332 18.7002L16.7669 12.2998' stroke={color} strokeMiterlimit={10} strokeLinecap='round' strokeLinejoin='round' />
      <Path
        d='M17.5 16.5H20L22.5 13L21 8.5H18L15.5 3.5H10.5L8 6.5H4L0.5 12L4 16.5H5.5'
        stroke={color}
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path d='M14.5 8.5H18' stroke={color} strokeMiterlimit={10} strokeLinecap='round' strokeLinejoin='round' />
    </Svg>
  ),
  OfflineIcon: ({ color = defaultColor, size = 24, ...props }: IconProps) => (
    <Svg width={size} height={size} viewBox='0 0 24 24' fill='none' {...props}>
      <Path d='M14.5 10.5H18' stroke={color} strokeMiterlimit={10} strokeLinecap='round' strokeLinejoin='round' />
      <Path d='M0.5 1.5L22.5 23.5' stroke={color} strokeMiterlimit={10} strokeLinecap='round' strokeLinejoin='round' />
      <Path d='M17.5 18.5H20L22.5 15L21 10.5H18L15.5 4.5H10.5L8 8.5H7.5' stroke={color} strokeMiterlimit={10} strokeLinecap='round' strokeLinejoin='round' />
      <Path d='M4.5 8.5H4L0.5 14L4 18.5H14.5' stroke={color} strokeMiterlimit={10} strokeLinecap='round' strokeLinejoin='round' />
    </Svg>
  ),
  UpdatingIcon: ({ color = defaultColor, size = 24, ...props }: IconProps) => (
    <Svg width={size} height={size} viewBox='0 0 24 24' fill='none' {...props}>
      <Path
        d='M21 12C20.9995 14.0389 20.3066 16.0173 19.035 17.611C17.7633 19.2048 15.9881 20.3195 14.0001 20.7726C12.0122 21.2258 9.92928 20.9904 8.09254 20.1052C6.25579 19.22 4.77406 17.7373 3.89 15.9M3.89 15.9L3.59 18.45L3.29 21M3.89 15.9L6.59 16.45L9.29 17M20.11 8.1C19.2259 6.26269 17.7442 4.78001 15.9075 3.89478C14.0707 3.00955 11.9878 2.77423 9.99987 3.22736C8.01192 3.68049 6.23674 4.7952 4.96505 6.38896C3.69336 7.98272 3.00052 9.96106 3 12M20.11 8.1L20.41 5.55L20.71 3M20.11 8.1L17.41 7.55L14.71 7'
        stroke={color}
        strokeLinecap='square'
      />
    </Svg>
  ),
});
